import React, { useState } from 'react';
import Header from '../../components/header';
import TimezoneInfo from '../../components/timezoneInfo';
import ReloadButton from '../../components/reloadButton';
import NotificationTools from '../../components/notificationTools';
import PointOfSaleContainer from '../../containers/pointOfSale';
import PortalSelector from '../../components/portalSelector';

const PointOfSaleScreen = () => {
  const [lastUpdated, setLastUpdated] = useState('');

  return (
    <div className="d-flex flex-column flex-fill">
      <Header
        title={'Point of Sale'}
        icon={'connection'}
        filters={<PortalSelector customLabel={'Portal'} />}
        actions={[
          { type: 'reactComponent', value: <TimezoneInfo key="timezone-info" /> },
          {
            type: 'reactComponent',
            value: <ReloadButton key="reload-btn" contentName="Point of Sale data" lastUpdatedCB={setLastUpdated} />
          },
          { type: 'reactComponent', value: <NotificationTools key="notification-btn" /> }
        ]}
      />
      <PointOfSaleContainer lastUpdated={lastUpdated} />
    </div>
  );
};

export default PointOfSaleScreen;
